import { Injectable } from '@angular/core';
import { catchError, forkJoin, map, Observable, of } from 'rxjs';
import { ChargeService } from './charge.service';
import { DeptBranchJobService } from './dept-branch-job.service';
import { PayrollConceptService } from './payroll-concept.service';
import { PayrollDefinitionService } from './payroll-definition.service';
import { SalaryScaleService } from './salary-scale.service';

@Injectable({
  providedIn: 'root'
})
export class TodoService {

  constructor(
    private chargeService: ChargeService,
    private salaryScaleService: SalaryScaleService,
    private payrollConceptService: PayrollConceptService,
    private deptBranchJobService: DeptBranchJobService,
    private payrollDefinitionService: PayrollDefinitionService
  ) {}

  getConfigurationStatus(): Observable<any> {
    return forkJoin({
      charges: this.chargeService.getCharges().pipe(catchError(() => of([]))),
      salaryScales: this.salaryScaleService.getScales().pipe(catchError(() => of([]))),
      payrollCatalogs: this.payrollConceptService.getCatalogs().pipe(catchError(() => of([]))),
      payrollCategories: this.payrollConceptService.getCategories().pipe(catchError(() => of([]))),
      departments: this.deptBranchJobService.getDepartments().pipe(catchError(() => of([]))),
      branches: this.deptBranchJobService.getBranches().pipe(catchError(() => of([]))),
      jobs: this.deptBranchJobService.getJobs().pipe(catchError(() => of([]))),
      payrollDefinitions: this.payrollDefinitionService.getPayrollDefinitions().pipe(catchError(() => of([])))
    }).pipe(
      map(res => ({
        charges: res.charges.length > 0,
        salaryScales: res.salaryScales.length > 0,
        payrollConcept: res.payrollCatalogs.length > 0 && res.payrollCategories.length > 0,
        deptBranchJob: res.departments.length > 0 && res.branches.length > 0 && res.jobs.length > 0,
        payrollDefinitions: res.payrollDefinitions.length > 0
      }))
    );
  }

}
